import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { JARGON, GALLERY } from "../data/content";

const JargonBuster = () => (
  <main data-testid="jargon-buster-page" className="bg-brand-bone">
    <Seo
      title="Mortgage Jargon Buster"
      description="Every confusing mortgage term, explained in plain English. From Agreement in Principle to Standard Variable Rate — the words banks use, decoded."
      path="/resources/jargon-buster"
      image={GALLERY[1]}
    />
    <PageHero
      testId="jargon-hero"
      eyebrow="Resources · Jargon Buster"
      title="The jargon buster."
      italic="Plain English, always."
      intro="Every mortgage term that sounds like it was invented to confuse you — explained in plain English."
      image={GALLERY[1]}
    />

    <section className="mx-auto max-w-4xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal>
        <Accordion type="single" collapsible className="space-y-3">
          {JARGON.map(([term, def], i) => (
            <AccordionItem
              key={term}
              value={`term-${i}`}
              data-testid={`jargon-item-${i}`}
              className="border border-black/10 bg-white px-6 transition-colors duration-200 data-[state=open]:border-brand/40"
            >
              <AccordionTrigger className="py-6 text-left font-serif text-lg font-medium text-brand-ink hover:text-brand hover:no-underline">
                {term}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-neutral-600">
                {def}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>

      <Reveal>
        <div className="relative mt-20 overflow-hidden bg-brand-ink p-10 sm:p-14">
          <img aria-hidden src={GALLERY[2]} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-ink via-brand-ink/90 to-brand-ink/70" />
          <div className="relative">
            <p className="eyebrow text-brand-gold"><span className="rule-line" />Ask us</p>
            <h2 className="editorial-h mt-6 text-3xl text-white sm:text-4xl">
              Still baffled by <span className="italic text-brand-gold">something?</span>
            </h2>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-white/70">
              Ask us — explaining this stuff is literally the job. No question is too small.
            </p>
            <Link
              to="/contact"
              data-testid="jargon-cta-btn"
              className="group mt-8 inline-flex items-center gap-2 bg-brand px-8 py-4 text-[0.78rem] font-semibold uppercase tracking-[0.22em] text-white transition-[background-color,transform] duration-200 hover:bg-brand-dark hover:-translate-y-0.5"
            >
              Ask a human
              <ArrowRight size={14} weight="bold" className="transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  </main>
);

export default JargonBuster;
